import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../../assets/images/logo.png";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    // Add event listener when menu is open
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    // Cleanup function
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close menu when pressing Escape key
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar" ref={navRef}>
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="GoalFlex" />
          <span className="logo-text">GoalFlex</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-menu">
          <Link to="/about" className="nav-link">
            About
          </Link>
          <Link to="/pickup-soccer" className="nav-link">
            Pickup Soccer
          </Link>
          <Link to="/how-it-works" className="nav-link">
            How It Works
          </Link>
          <Link to="/contact" className="nav-link">
            Contact
          </Link>
          <Link to="/blog" className="nav-link">
            Blog
          </Link>
          <Link to="/careers" className="nav-link">
            Careers
          </Link>
        </div>

        {/* CTA Buttons */}
        <div className="nav-cta">
          <Link to="/download" className="nav-download">
            Download App
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <div
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle mobile menu"
          aria-expanded={isMenuOpen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setIsMenuOpen(!isMenuOpen);
            }
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Mobile Menu Backdrop */}
      {isMenuOpen && (
        <div
          className="mobile-menu-backdrop"
          onClick={() => setIsMenuOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
        <Link
          to="/about"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          About
        </Link>
        <Link
          to="/pickup-soccer"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Pickup Soccer
        </Link>
        <Link
          to="/how-it-works"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          How It Works
        </Link>
        <Link
          to="/contact"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Contact
        </Link>
        <Link
          to="/blog"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Blog
        </Link>
        <Link
          to="/careers"
          className="mobile-link"
          onClick={() => setIsMenuOpen(false)}
        >
          Careers
        </Link>
        <div className="mobile-cta">
          <Link
            to="/download"
            className="mobile-download"
            onClick={() => setIsMenuOpen(false)}
          >
            Download App
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
